exports = module.exports = require("../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/server/server.component.css
// module id = ../../../../../src/app/server/server.component.css
// module chunks = main